import * as React from 'react';
import { Button } from '../Button/Button';
import { ButtonType } from '../Button/ButtonType.csharp';
import { List } from '../List/List';
import { Shortcut } from '../Shortcut/Shortcut';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { smoothScrollToSectionById } from '../Utils/utils';
import styles from './NavigationBlock.module.css';
import type { NavigationBlockProps } from './NavigationBlockProps.csharp';

export const NavigationBlock: React.FC<React.PropsWithChildren<NavigationBlockProps>> = props => {
    const { anchors, links } = props;

    const handleAnchorClick = (anchorId: string) => {
        smoothScrollToSectionById(anchorId);
    };

    return (
        <div>
            {anchors && (
                <List
                    items={anchors}
                    className={styles.Anchors}
                    renderItem={item => (
                        <li key={item.id}>
                            <Button
                                onClick={() => handleAnchorClick(item.id)}
                                type={ButtonType.Clear}
                                className={styles.Anchor}
                            >
                                <span>{item.label}</span>
                                <SvgIcon iconName="arrow-down" />
                            </Button>
                        </li>
                    )}
                />
            )}
            {links && (
                <List
                    items={links}
                    className={styles.Links}
                    renderItem={item => (
                        <li key={item.label}>
                            <Shortcut {...item} type="solid" variant="primary" size="responsiveFromMediumToSmall" />
                        </li>
                    )}
                />
            )}
        </div>
    );
};
